var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLines3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 909 296.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.2,187.21c50.39-21.78,70.62,47.76,262.73,47.38,149.81-14.08,206.27-23.38,226.96-137.72,19.1-105.54,199.81-138.63,311.59-26.44,34.19,47.11,105.49,138.59,107.26,137.53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.2,226.08c46.85-20.04,114.03,47.64,295.22,36.69,102.86-9.37,149.48-8.72,190.98-47.32,20.83-19.38,35-82.31,43.6-114.28,15.44-57.4,89.08-81.04,143.05-65.8,53.55,15.12,76.61,22.55,117.92,75.3,37.71,48.15,113.21,131.99,117.52,133.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.2,258c43.11-17.7,161.15,49.62,326.59,36.36,128.65-10.31,220.74-25.51,226.6-123.42,8.03-134.02,132.3-150.13,236.6-10.85,28.17,38.36,116.98,125.16,118.5,124.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines3);
export default __webpack_public_path__ + "static/media/lines_3.68f1080a32bbb6ddf69abfb7faa4c29d.svg";
export { ForwardRef as ReactComponent };